const SET_INDEX = 'setDeviceIndex';
const SET_LIST = 'setDeviceList';
const SET_CURRENT_DETAIL = 'setCurDetailData';
const SET_CURRENT_FILE_LIST = 'setDeviceFileList';
const SET_CURRENT_CONFIG = 'setCurConfig';
const SET_REFRESH_RESULT = 'setRefreshResult';
const SET_SEARCH_VAL = 'setSearchVal';
const SET_FILE_LIST_OVERALL = 'setFileListOverall';
const SET_CURRENT_ONLINE = 'setCurOnline';
const SET_UPLOADING_LIST = 'setuploadingList';
const SET_IS_UPLOADING = 'setisUploading';
const SET_OTA_ERRORMSG = 'setotaErrorMsg';
const SET_OTA_STATUS = 'setOtaStatus';

export default {
  SET_CURRENT_ONLINE,
  SET_INDEX,
  SET_LIST,
  SET_CURRENT_DETAIL,
  SET_CURRENT_FILE_LIST,
  SET_CURRENT_CONFIG,
  SET_REFRESH_RESULT,
  SET_SEARCH_VAL,
  SET_FILE_LIST_OVERALL,
  SET_UPLOADING_LIST,
  SET_IS_UPLOADING,
  SET_OTA_ERRORMSG,
  SET_OTA_STATUS,
};



// WEBPACK FOOTER //
// ./src/store/modules/device/mutations-types.js